import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCopy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.00001 2.25C3.92948 2.25 2.25002 3.92675 2.25001 5.99835L2.25 15C2.25 15.96 2.61169 16.8372 3.20504 17.5002C3.48129 17.8088 3.95543 17.8351 4.26408 17.5589C4.57272 17.2826 4.59899 16.8085 4.32274 16.4998C3.96602 16.1012 3.75 15.5767 3.75 15L3.75001 5.99836C3.75001 4.75625 4.75684 3.75 6.00001 3.75H15C15.5767 3.75 16.1012 3.96602 16.4998 4.32274C16.8085 4.59899 17.2826 4.57272 17.5589 4.26408C17.8351 3.95543 17.8088 3.48129 17.5002 3.20504C16.8372 2.61169 15.96 2.25 15 2.25H6.00001Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 5.25C6.92893 5.25 5.25 6.92893 5.25 9V18C5.25 20.0711 6.92893 21.75 9 21.75H18C20.0711 21.75 21.75 20.0711 21.75 18V9C21.75 6.92893 20.0711 5.25 18 5.25H9ZM6.75 9C6.75 7.75736 7.75736 6.75 9 6.75H18C19.2426 6.75 20.25 7.75736 20.25 9V18C20.25 19.2426 19.2426 20.25 18 20.25H9C7.75736 20.25 6.75 19.2426 6.75 18V9Z",
		fill: "currentColor"
	})]
});
export { SvgIconCopy as ReactComponent };
